import ExternalAccount from './ExternalAccount'

function KHDN() {
  return <ExternalAccount scope="khdn" />
}

export default KHDN
